import React from 'react';
import { useSelector } from 'react-redux';
import { GlobalVariables } from '../../../../GlobalVariables';
import { lastCurrenciesState } from '../../../../redux/slices/tsSlice';

export interface IFormCurrencyInputData {
    idx: string;
    label: string;
    amount: string;
    currency: string;
    type: 'edit' | 'locked' | 'warning' | 'empty'
    onChange?: (amount: string, currency: string) => void;
    onSave?: (amount: string, currency: string) => void;
}

const CurrencyInput = (props: IFormCurrencyInputData) => {
    const lastCurrenciesUpdatedTS = useSelector(lastCurrenciesState);

    console.log('CurrencyInput:', props);
    const { idx, label, amount: propsAmount, currency: propsCurrency, type, onChange /*, onSave */ } = props;

    const [amount, setAmount] = React.useState('0');
    const [currency, setCurrency] = React.useState('');

    React.useEffect(() => {
        console.log('setBoth:', propsAmount, propsCurrency);
        setAmount(propsAmount);
        setCurrency(propsCurrency);
    }, [propsAmount, propsCurrency])

    React.useEffect(() => {
        if (onChange) {
            onChange(amount, currency);
        }
    }, [amount, currency, onChange]);

    const renderData = React.useMemo(() => {
        const currencySymbol = GlobalVariables.currencySymbol(currency);

        return (
            <div className="min-h-[67.5px] self-stretch flex flex-col justify-center items-start gap-2 text-text-dark">
                <div className="relative self-stretch w-full flex items-center bg-white overflow-hidden transition-colors">
                    <div className="self-stretch w-full justify-start text-sm font-normal font-['Inter'] leading-tight">{label}</div>
                </div>
                
                <div className="relative flex rounded-lg w-full">
                    <input
                        id={`currencyInput-${label.replaceAll(' ', '').trim()}-${idx}`}
                        type="text"
                        disabled={type === 'locked'}
                        className={`py-1.5 sm:py-2 ${currencySymbol ? `padLeft-${currencySymbol.length}` : 'padLeft-0' } pr-20 block w-full bg-bg-input-${type} rounded-lg outline outline-1 outline-offset-[-0.50px] border-border-default inline-flex justify-start items-center gap-2.5 overflow-hidden`}
                        value={amount}
                        onChange={(e) => {
                            setAmount(e.currentTarget.value);
                        }}
                    />
                    <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4">
                        <span className="dark:text-neutral-500">{currencySymbol}</span>
                    </div>
                    {type !== 'locked' && <div className="absolute inset-y-0 end-2 flex items-center pe-px">
                        <label htmlFor="hs-inline-leading-select-currency" className="sr-only">Currency</label>
                        <select
                            id="hs-inline-leading-select-currency"
                            name="hs-inline-leading-select-currency"
                            className="block w-full border-transparent rounded-lg focus:ring-blue-600 focus:border-blue-600 dark:text-neutral-500 dark:bg-neutral-900"
                            value={currency}
                            onChange={(e) => {
                                setCurrency(e.currentTarget.value);
                            }}
                        >
                            <option key='value-empty' value="" disabled={true}>---</option>
                            {GlobalVariables.currencies.map(c => <option key={`value-${c.currency_code}`} value={c.currency_code}>{c.currency_code}</option>)}
                        </select>
                    </div>}
                </div>
            </div>
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastCurrenciesUpdatedTS, amount, currency, idx, label, type]);

    return renderData;
};

export default CurrencyInput;